<header class="wow fadeInUp" data-wow-delay="0.2s">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12" style="background:#263643; height:268px; padding-left: 0px;">
                <div style="margin-top:30px;margin-left:40px;">
                    <a class="logo" style="width:60px;" href="index.html">
                        <img style="width:40px;" src="assets/img/infinitylearn_logo.png"
                            alt="Infinity Learn"> </a>
                    <p
                        style="font-family: MontSerrat; color:#FAFAFA; font-weight: 600; font-size: 20px; font-style: normal;">
                        <!-- <a>INFINITY LEARN</a> -->
                    </p>
                </div>
            </div>
        </div>
    </div>
</header>
